<template>
    <div v-if="isloading" class="text-center mt-4 mb-5">
      <v-progress-circular
          indeterminate
          color="primary"
          class="bottom"
          />
      </div>
</template>
<script>
export default {
  name: 'InfiniteScrollBottom',
  data() {
    return {
      bottom: false,
      isloading: false,
      countryId: null,
      timeout: null
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      this.bottom = this.bottomVisible()
    })
  },
  computed: {
  },
  methods: {
    bottomVisible() {
      const scrollY = window.scrollY
      const visible = window.innerHeight
      // chiều cao của toàn bộ tài liệu
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = (visible + scrollY + 250) >= pageHeight
      return bottomOfPage || (pageHeight < visible)
    },
    addMoreData() {
      this.isloading = true
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async() => {
        this.$emit('loadMore')
      }, 500)
    }
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.addMoreData()
      }
    },
  },
}
</script>

